import React, { useContext, useState } from 'react';
import { Button } from 'antd';

import AddEditDialog from '@totem/components/billingRates/AddEditDialog';
import ReportContext from '@totem/components/billingRates/BillingRateReportContext';
import { getNewBillingRateData } from '@totem/components/billingRates/dataTypes';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const AddBillingRateButton = () => {
  const { userProfile } = useContext(UserProfileContext);
  const [open, setOpen] = useState<boolean>(false);
  const { loading, onAction } = useContext(ReportContext);
  const isDisabled =
    !permissions.organizationalAdministrator.hasPermissions(userProfile);

  const handleCloseDialog = (refresh: boolean) => {
    setOpen(false);
    if (refresh) {
      onAction('refresh', null);
    }
  };

  return (
    <>
      <Button type="primary" onClick={() => setOpen(true)}>
        Add Billing Rate
      </Button>
      {open && !isDisabled && (
        <AddEditDialog
          open={open}
          loading={loading}
          billingRateData={getNewBillingRateData()}
          onClose={handleCloseDialog}
        />
      )}
    </>
  );
};

export default AddBillingRateButton;
